import { FC, useEffect, useState } from "react"
import { Button, Grid, Paper, Typography, Divider, Box } from '@mui/material'
import categoria_prueba from '../../assets/image/categoria_prueba.png';
import { SearcherKFCProductModal } from "./components/SearcherKFCProductModal";
import { moneyFormat } from "../../toolbox/helpers/money-helpers";
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';
import { readLocalStorage, saveLocalStorage } from "../../toolbox/helpers/local-storage-helpers";
import { LocalStorageKey } from "../../types";
import { useShoppingCartStore } from "../../hooks/useShoppingCartStore";
import { useSearcherStore } from "../../hooks/useSearcherStore";
import { CustomSnackbar } from "../../components/common/CustomSnackbar/CustomSnackbar";
import { styled } from '@mui/material/styles';

const Div = styled('div')(({ theme }) => ({
    ...theme.typography.button,
    padding: theme.spacing(1),
    fontWeight: 'bold',
    fontSize: '20px',
    color: 'rgba(102, 102, 102, 0.4)',
}));

const categoryProduct = [
    {
        id: 1, category: 'Llantas', products: [
            { id: 1, name: 'Llanta' },
            { id: 2, name: 'Llanta' },
            { id: 3, name: 'Llanta' },
            { id: 4, name: 'Llanta' },
            { id: 5, name: 'Llanta' },
            { id: 6, name: 'Llanta' },
            { id: 7, name: 'Llanta' },
            { id: 8, name: 'Llanta' },
            { id: 9, name: 'Llanta' },
            { id: 10, name: 'Llanta' },
        ]
    },
    {
        id: 2, category: 'Llantas', products: [
            { id: 1, name: 'Llanta' },
            { id: 2, name: 'Llanta' },
            { id: 3, name: 'Llanta' },
            { id: 4, name: 'Llanta' },
            { id: 5, name: 'Llanta' },
            { id: 6, name: 'Llanta' },
            { id: 7, name: 'Llanta' },
            { id: 8, name: 'Llanta' },
            { id: 9, name: 'Llanta' },
            { id: 10, name: 'Llanta' },
        ]
    }
]

const skeletons = ['test1', 'test2', 'test3', 'test4', 'test5'];

export const ProductsKFC: React.FC<any> = (props): JSX.Element | any => {

    const { setProducts, products, getFilterProducts, page, setPage, perPage, totalRecords = 0, loadingproducts, setTypeList, typeList,
        filterCode,
        setFilterCode,
        category,
        setCategory,
        subcategory,
        setSubcategory,
        line,
        setLine,
        marca,
        setMarca,
        modelo,
        setModelo
     } = props;

    const { selectedCustomer } = useSearcherStore();
    const { createShoppingCart, getShoppingCart } = useShoppingCartStore();
    const [productByCategory, setProductByCategory] = useState<any[]>([])

    const userData = readLocalStorage(LocalStorageKey.USER_DATA);
    const idusersession = userData?.id;

    const [loadingcart, setLoadingcart] = useState(false);
    const [loadingdata, setLoadingdata] = useState(false);
    const [showModalProduct, setShowModalProduct] = useState<boolean>(false);
    const [cardState, setCardState] = useState<any>([]);
    const [productSelected, setproductSelected] = useState<any>('');
    const [groupedProducts, setGroupedProducts] = useState<any>([]);

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    useEffect(() => {
        getFilterProductsApi();
    }, [page, perPage]);

    useEffect(() => {
        const groupByCategory = (products) => {
            const categories = {};

            products.forEach((product) => {
                const { idcategory_product, category_product } = product;
                if (!categories[idcategory_product]) {
                    categories[idcategory_product] = {
                        name: category_product,
                        products: []
                    };
                }
                categories[idcategory_product].products.push(product);
            });

            return Object.values(categories);
        };

        const list = Array.isArray(products) ? products : (products?.detail ?? []);
        if (list.length > 0) {
            setGroupedProducts(groupByCategory(list));
        }
    }, [products]);

    const getFilterProductsApi = () => {
        setProducts([]);
        setTypeList('general');
        getFilterProducts && getFilterProducts();
    }

    const getShoppingCartApi = async () => {
        setLoadingcart(true);
        const datacart = {
            iduser_created: idusersession,
            idcustomer: selectedCustomer?.id,
            page: "",
            perPage: ""
        }
        const response = await getShoppingCart(datacart)
        if (response && response.length > 0) {
            const { detail, ...otherfields } = response[0];
            setCardState(detail || []);
            setLoadingcart(false);
        } else {
            setCardState([]);
            setLoadingcart(false);
            return false;
        }
    }

    const createorupdateCartAPI = async (data) => {
        try {
            setLoadingdata(true);
            const response = await createShoppingCart(data);
            console.log(response);
            if (response) {
                setLoadingdata(false);
            } else {
                setLoadingdata(false);
                return false;
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const handleSelectProduct = (product, quantity = 1) => {

        // if(!selectedCustomer) return CustomSnackbar('error', "Asegúrese de seleccionar un cliente.");

        let card = [...cardState];
        console.log(card)
        console.log(product)
        let exits: boolean = false;
        if (product) {
            for (let i = 0; i < card.length; i++) {
                if (card[i].codesystem_product === product.codesystem_product && card[i].name_product === product.name_product) {
                    // if(card[i].quantity < card[i].stock){
                    //     card[i].quantity = card[i].quantity ? card[i].quantity+1 : 2
                    // }
                    // if(card[i].quantity === card[i].stock){
                    //     alert('no hay suficiente stock');
                    // }
                    exits = true;
                }
            }
            if (!exits) {
                card.push({
                    ...product,
                    quantity: quantity,
                    discount: product.discount || 0,
                });

                /* GUARDANDO EN API */
                const datacart = {
                    iduser_created: idusersession,
                    idcustomer: selectedCustomer?.id,
                    idproduct: product?.idproduct,
                    quantity: quantity,
                }
                createorupdateCartAPI(datacart);
            }

            /* PARA OBTENER CONTADOR DEL CARRITO */
            getShoppingCartApi();
        }
    }

    const onSeeMore = (product) => {
        setproductSelected(product)
        setShowModalProduct(true)
    }

    return (
        <Grid container spacing={2} columnSpacing={3} sx={{ width: '100%', display: 'flex', flexWrap: 'wrap', alignItems: 'center', alignContent: 'center', justifyContent: 'space-around', height: '100%' }}>

            {
                (typeList == 'general' && products.length > 0) && (
                    <>
                        {
                        //   groupedProducts.flatMap((category) => ( 
                            (products || []).map((product) => (
                              <Grid item xs={12} sm={6} md={4} lg={2.4}>
                                <Paper elevation={5} sx={{ 
                                  width: "100%", 
                                  height: '440px', 
                                  margin: '10px', 
                                  padding: '20px', 
                                  display: 'flex', 
                                  flexDirection: 'column', 
                                  justifyContent: 'space-between', 
                                  alignItems: 'center', 
                                  borderRadius: '10px', 
                                  backgroundColor: '#f9f9f9', 
                                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', 
                                  position: 'relative'
                                }}>
                                  
                                  <div style={{ 
                                    position: 'absolute', 
                                    top: '10px', 
                                    left: '10px', 
                                    backgroundColor: '#4A90E2', 
                                    color: '#fff', 
                                    padding: '5px 10px', 
                                    borderRadius: '5px', 
                                    fontSize: '12px' 
                                  }}>
                                    {/* {product.category_product || 'Sin categoría'} */}
                                    {Array.from(
                                        new Set(
                                            product.relationProductAttributes.map(
                                                (attr: any) => attr.parent_attribute?.name
                                            )
                                        )
                                    )
                                        .filter(Boolean) // Esto elimina los valores null o undefined
                                        .join(', ') || 'Sin categoria'}
                                  </div>
                        
                                  <div style={{ 
                                    width: '100%', 
                                    height: '160px', 
                                    display: 'flex', 
                                    justifyContent: 'center', 
                                    alignItems: 'center', 
                                    marginBottom: '10px' 
                                  }}>
                                    <img style={{ 
                                      maxWidth: '100%', 
                                      maxHeight: '100%', 
                                      objectFit: 'contain', 
                                      borderRadius: '10px' 
                                    }} src={categoria_prueba} alt="Categoria Prueba" />
                                  </div>
                        
                                  <div style={{ 
                                    width: '100%', 
                                    height: '100px', 
                                    textAlign: 'left', 
                                    display: 'flex', 
                                    alignItems: 'center' 
                                  }}>
                                    <Typography fontWeight={'600'} fontSize={'16px'} sx={{ 
                                      marginBottom: '5px', 
                                      wordWrap: 'break-word' 
                                    }}>
                                      {product.codesystem_product || ''} {product.name_product || '-----'}
                                    </Typography>
                                  </div>
                        
                                  <div style={{ 
                                    width: '100%', 
                                    textAlign: 'left'
                                  }}>
                                    {/* <Typography fontWeight={'500'} fontSize={'14px'} sx={{ marginBottom: '5px' }}>
                                      Subfamilia: {product.subcategory_product?.name || 'Sin subcategoría'}
                                    </Typography> */}
                                     <Typography fontWeight={'500'} fontSize={'14px'} sx={{ marginBottom: '5px' }}>
                                      Modelo: 
                                                {product.relationProductAttributes
                                                    .map((attr: any) => attr.child_attribute?.name)
                                                    .filter(Boolean) // Esto elimina los valores null o undefined
                                                    .join(', ')}
                                      </Typography>
                                  </div>
                                  <div style={{ 
                                    width: '100%', 
                                    textAlign: 'left'
                                  }}>
                                    <Typography fontWeight={'500'} fontSize={'14px'} sx={{ marginBottom: '5px' }}>
                                      Línea: {product.specificsubcategory_product?.name || 'Sin línea'}
                                    </Typography>
                                  </div>
                        
                                  <Grid item sx={{ 
                                    width: '100%', 
                                    display: 'flex', 
                                    justifyContent: 'left', 
                                    alignItems: 'left' 
                                  }}>
                                    {product.offerprice_product !== 0 && (
                                      <Typography fontWeight={'500'} fontSize={'14px'} color={'red'} style={{ 
                                        textDecoration: 'line-through', 
                                        marginRight: '10px' 
                                      }}>
                                        {moneyFormat(product.offerprice_product, '$') || '-----'}
                                      </Typography>
                                    )}
                                    <Typography fontWeight={'700'} fontSize={'20px'} color={'#000'}>
                                      {product.offerprice_product ? moneyFormat(product.offerprice_product, '$') : 
                                        (product.price_product ? moneyFormat(product.price_product, '$') : '-----')
                                      }
                                    </Typography>
                                  </Grid>
                        
                                  {/* Botón "Añadir al carrito" con animación y un nuevo color */}
                                  <Grid item sx={{ 
                                    width: '100%', 
                                    display: 'flex', 
                                    justifyContent: 'center', 
                                    padding: '10px 0'
                                  }}>
                                    <Button 
                                      onClick={() => handleSelectProduct(product)} 
                                      sx={{ 
                                        borderRadius: '20px', 
                                        fontSize: '10px', 
                                        backgroundColor: '#EBA058', 
                                        color: '#fff', 
                                        height: '30px', 
                                        padding: '0 15px', 
                                        margin: '5px', 
                                        transition: 'transform 0.3s ease', // Animación para el botón
                                        '&:hover': { 
                                          transform: 'scale(1.1)', // Crece cuando se pasa el cursor
                                          backgroundColor: '#d9924e', // Color más oscuro en hover
                                        }
                                      }}
                                    >
                                      Seleccionar
                                    </Button>
                                  </Grid>
                                </Paper>
                              </Grid>
                            ))
                        //   ))
                        }
                        
                    </>
                )
            }

            {
                (typeList == 'byCategory' && products.length > 0) && (
                    <>
                        <Grid item container xs={12} spacing={2}>
                            <Grid item xs={12} md={2} sx={{ display: 'flex', justifyContent: 'center' }}>
                                <Typography sx={{ color: 'rgba(0, 0, 0, 0.3)', fontSize: '18px' }}>{products[0]?.category_product || '-----'}</Typography>
                            </Grid>
                            <Grid item xs={12} md={10} sx={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                                <Divider sx={{ width: '95%', height: '2px', backgroundColor: 'rgba(0, 0, 0, 0.3)' }} />
                            </Grid>
                        </Grid>
                        <Grid item container xs={12} spacing={2}>
                            {
                                (products).map((product) => (
                                    <Grid item xs={12} md={2.4}>
                                        <Paper elevation={5} sx={{ width: "100%", height: '270px', margin: '10px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <img style={{ width: '140px', height: '140px' }} src={categoria_prueba} alt="Categoria Prueba" />
                                            <Divider sx={{ width: '100%', height: '1px', backgroundColor: 'rgba(0, 0, 0, 0.3)', marginTop: '5px' }} />

                                            <Grid item sx={{ width: '100%', marginLeft: 'auto' }}>
                                                {
                                                    product.offerprice_product && (
                                                        <Typography fontWeight={'500'} fontSize={'12px'} color={'red'} style={{ textDecoration: 'line-through', marginRight: '10px' }}>{moneyFormat(product.price, '$') || '-----'}</Typography>
                                                    )
                                                }
                                                <Typography fontWeight={'500'} fontSize={'12px'}>
                                                    {
                                                        product.offerprice_product ? moneyFormat(product.offerprice_product, '$') :
                                                            (product.price ? moneyFormat(product.price, '$') : '-----')
                                                    }
                                                </Typography>
                                            </Grid>

                                            <Grid item sx={{ width: '100%', marginLeft: 'auto', display: 'flex', flexDirection: 'column' }}>
                                                <Typography fontWeight={'600'} fontSize={'14px'}>{product.name_product || '-----'}</Typography>
                                                <Typography fontSize={'12px'} sx={{ width: { xs: '160px', sm: '160px', md: '160px', lg: '200px', xl: '230px' }, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                    {product.description_product || '-----'}
                                                </Typography>
                                            </Grid>

                                            <Grid item sx={{ width: '100%' }}>
                                                <Button onClick={() => onSeeMore(product)} sx={{ border: '2px solid #D0D0D0', borderRadius: '20px', fontSize: '7px', color: '#707070', height: '25px', margin: '5px' }}>
                                                    Ver más
                                                </Button>
                                                <Button onClick={() => handleSelectProduct(product)} sx={{ borderRadius: '20px', fontSize: '7px', backgroundColor: '#EBA058', color: '#fff', height: '25px' }}>
                                                    Seleccionar
                                                </Button>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </>
                )
            }

            {
                loadingproducts && skeletons.map((item) => (
                    <Grid item xs={12} md={2.4}>
                        <Paper elevation={5} sx={{ width: "100%", height: '270px', margin: '10px', padding: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Skeleton sx={{ width: '140px', height: '140px' }} animation="wave" variant="rectangular" />

                            <Divider sx={{ width: '100%', height: '1px', backgroundColor: 'rgba(0, 0, 0, 0.3)', marginTop: '5px' }} />
                            <span style={{ marginTop: '2px', marginBottom: '2px' }}></span>

                            <Grid item sx={{ width: '100%', marginLeft: 'auto', display: 'flex' }}>
                                <Skeleton sx={{ width: '100px', height: '15px' }} animation="wave" variant="rectangular" />
                                <span style={{ marginRight: '2px', marginLeft: '2px' }}></span>
                                <Skeleton sx={{ width: '100px', height: '15px' }} animation="wave" variant="rectangular" />
                            </Grid>

                            <Grid item sx={{ width: '100%', marginLeft: 'auto', display: 'flex', flexDirection: 'column' }}>
                                <span style={{ marginTop: '2px', marginBottom: '2px' }}></span>
                                <Skeleton sx={{ width: '140px', height: '15px' }} animation="wave" variant="rectangular" />
                                <span style={{ marginTop: '2px', marginBottom: '2px' }}></span>
                                <Skeleton sx={{ width: { xs: '160px', sm: '160px', md: '160px', lg: '200px', xl: '230px' }, height: '15px' }} animation="wave" variant="rectangular" />
                            </Grid>
                            <span style={{ marginTop: '4px', marginBottom: '4px' }}></span>

                            <Grid item sx={{ width: '100%', display: 'flex' }}>
                                <Skeleton sx={{ width: '100px', height: '20px' }} animation="wave" variant="rectangular" />
                                <span style={{ marginRight: '2px', marginLeft: '2px' }}></span>
                                <Skeleton sx={{ width: '100px', height: '20px' }} animation="wave" variant="rectangular" />
                            </Grid>
                        </Paper>
                    </Grid>
                ))
            }

            {
                products.length == 0 && !loadingproducts && (
                    <Grid item container xs={12}>
                        <Box sx={{ backgroundColor: 'rgba(224, 224, 224, 0.5)', padding: '15px', borderRadius: '10px', height: '270px', justifyContent: 'center', alignItems: 'center', display: 'flex', width: '100%' }} >
                            <Div>{"NO SE ENCONTRARON PRODUCTOS"}</Div>
                        </Box>
                    </Grid>
                )
            }

            {/* PAGINACION DE PRODUCTOS */}
            <Grid item xs={12} display='flex' justifyContent='center'>
                <Stack spacing={2}>
                    <Pagination
                        count={Math.max(1, Math.ceil((totalRecords || 0) / (perPage || 1)))}
                        page={page}
                        onChange={handlePageChange}
                        variant="outlined"
                        shape="rounded"
                    />
                </Stack>
            </Grid>

            {
                showModalProduct &&
                <SearcherKFCProductModal
                    open={showModalProduct}
                    closeModal={() => setShowModalProduct(false)}
                    product={productSelected}
                    setproductSelected={setproductSelected}
                    addToCart={handleSelectProduct}
                />
            }

        </Grid>

    )

}

